import parse, { Element, HTMLReactParserOptions } from "html-react-parser";
import React from "react";

import removeElementButKeepChildren from "./removeElementButKeepChildren";
import replaceCookieDeclaration from "./replaceCookieDeclaration";
import injectHubspot from "./replaceHubspotform";
import wrapBackgroundBleed from "./wrapBackgroundBleed";
import wrapBlockquoteBleed from "./wrapBlockquoteBleed";
import wrapSpecs from "./wrapSpecs";

const all = [
  injectHubspot,
  wrapBlockquoteBleed,
  removeElementButKeepChildren,
  wrapBackgroundBleed,
  wrapSpecs,
  replaceCookieDeclaration,
];

const options = {
  replace,
} as HTMLReactParserOptions;

function replace(element: Element): React.ReactNode {
  if (element.type !== "tag") {
    return;
  }

  for (const replacer of all) {
    if (replacer.supports(element)) {
      return replacer.replace(element, options);
    }
  }
}

export default function replaceContent(
  content: string
): ReturnType<typeof parse> {
  return parse(content, options);
}
